/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

class AdPopUp extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  getLinkUrl(url) {
    return url.indexOf('http') !== -1 ? url : `//${url}`;
  }

  render() {
    const adArray = this.props.items;
    const toDisplay = adArray[Math.floor(Math.random() * adArray.length)];
    const { image_uid } = toDisplay;
    return (
      <div
        id="mobile-ad-2"
        className="mobile-ad-box mobile-ad-dark mobile-ad-large timed-mobile-box"
      >
        <a href="#" className="close-mobile-ad">
          <i className="fa fa-times" />
        </a>
        <a
          href={this.getLinkUrl(toDisplay.image_url)}
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="popup-ads"
            className="preload-image responsive-image"
            src={image_uid}
          />
        </a>
      </div>
    );
  }
}

export default AdPopUp;
